module.exports = __webpack_public_path__ + "img/c04_unitstartechimmortalchampion_Normal_ua.b716d510.webp";